// src/components/v2/components/PreviewModal.jsx
import React from 'react';
import {
    Modal,
    Box,
    Paper,
    Typography,
    IconButton,
    AppBar,
    Toolbar,
    Container
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RuntimeWizard from './RuntimeWizard';
import { convertToJSONSchema } from '../utils/schemaConverter';

const PreviewModal = ({ open, onClose, wizard }) => {
    const [formData, setFormData] = React.useState({});

    const handleFormDataChange = (data) => {
        setFormData(data);
    };

    if (!wizard) return null;

    // Convert wizard to schema for preview
    const jsonSchema = convertToJSONSchema(wizard);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                overflow: 'auto',
                p: 2
            }}
        >
            <Box sx={{
                width: '100%',
                maxWidth: 1200,
                mt: 2,
                mb: 2
            }}>
                <Paper elevation={3}>
                    <AppBar position="static" color="primary">
                        <Toolbar>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>
                                Preview: {wizard.name}
                            </Typography>
                            <IconButton
                                edge="end"
                                color="inherit"
                                onClick={onClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Container maxWidth="md" sx={{ py: 3 }}>
                        <RuntimeWizard
                            wizardSchema={jsonSchema}
                            initialData={formData}
                            onDataChange={handleFormDataChange}
                        />
                    </Container>
                </Paper>
            </Box>
        </Modal>
    );
};

export default PreviewModal;